
// FORCE SQUARE IMAGES - NO OVALS
(function() {
    function forceSquare() {
        // Remove all clip paths and shapes
        const allElements = document.querySelectorAll('*');
        allElements.forEach(el => {
            if (el.style.clipPath || el.style.webkitClipPath) {
                el.style.clipPath = 'none';
                el.style.webkitClipPath = 'none';
            }
        });

        // NOTE: grid-forcing removed. This block used to set
        //   display:grid; grid-template-columns:repeat(2,1fr)
        // inline on every `.grid`/`ul.grid` on the site, which broke the
        // homepage "Shop by Brand" collection-list (cards collapsed, images
        // hidden) and overrode the collection page's own grid. The theme's
        // native flex grid handles columns correctly, so it was removed.

        // Make all media containers square
        const mediaContainers = document.querySelectorAll('.card__media, .media, .card__inner');
        mediaContainers.forEach(container => {
            container.style.width = '100%';
            container.style.paddingBottom = '100%';
            container.style.position = 'relative';
            container.style.overflow = 'hidden';
            container.style.borderRadius = '0';
            container.style.clipPath = 'none';
            container.style.webkitClipPath = 'none';
            container.style.shapeOutside = 'none';

            // Remove any CSS classes that might add shapes
            container.classList.remove('card--shape', 'media--square', 'media--portrait', 'media--landscape');
        });

        // Make images fill the square
        const images = document.querySelectorAll('.card__media img, .media img');
        images.forEach(img => {
            img.style.position = 'absolute';
            img.style.top = '0';
            img.style.left = '0';
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.objectFit = 'cover';
            img.style.borderRadius = '0';
            img.style.clipPath = 'none';
            img.style.webkitClipPath = 'none';
        });

        // Remove any SVG masks
        document.querySelectorAll('.card__media svg, .media svg').forEach(svg => {
            svg.style.display = 'none';
        });

        // Remove frames and borders
        document.querySelectorAll('.card--product, .card-wrapper').forEach(card => {
            card.style.border = 'none';
            card.style.boxShadow = 'none';
            card.style.background = 'transparent';
        });

        // Fix grid items: make each item fill its grid/flex cell. (On the
        // flex collection-list this is capped by the theme's max-width:33%,
        // so it stays 3 columns; on the product-grid sliders it lets the
        // slide fill the cell instead of collapsing.)
        document.querySelectorAll('.grid__item').forEach(item => {
            item.style.width = '100%';
            item.style.padding = '0';
            item.style.margin = '0';
        });
    }

    // Apply immediately
    forceSquare();

    // Apply after DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', forceSquare);
    } else {
        forceSquare();
    }

    // Apply after load
    window.addEventListener('load', forceSquare);

    // NOTE: resize handler removed (it re-forced the 2-column grid on resize).

    // Keep applying
    setTimeout(forceSquare, 100);
    setTimeout(forceSquare, 500);
    setTimeout(forceSquare, 1000);
    setTimeout(forceSquare, 2000);

    // Override any dynamic style changes
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                const target = mutation.target;
                if (target.classList.contains('card__media') || target.classList.contains('media')) {
                    if (target.style.clipPath && target.style.clipPath !== 'none') {
                        target.style.clipPath = 'none';
                        target.style.borderRadius = '0';
                    }
                }
            }
        });
    });

    // Observe all media elements
    document.querySelectorAll('.card__media, .media').forEach(el => {
        observer.observe(el, { attributes: true });
    });
})();

